export default __webpack_public_path__ + "static/media/contemporary-mobile.40d252e3.png";